export function LoadingComments() {
  return (
    <div className="comment comment-is-loading" data-author="" aria-hidden="true">
      <div className="comment-body">
        <span className="comment-text">Loading comments&hellip;</span>
      </div>
    </div>
  );
}
